// extracted by mini-css-extract-plugin
export var box = "_3p-2";
export var checkboxControl = "_3p-0";
export var checkboxRow = "_3p-a";
export var checked = "_3p-3";
export var descriptionSpacer = "_3p-c";
export var disabled = "_3p-4";
export var icon = "_3p-8";
export var input = "_3p-1";
export var labelSpacer = "_3p-b";
export var large = "_3p-7";
export var medium = "_3p-6";
export var small = "_3p-5";
export var text = "_3p-9";